import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import TopNav from "../components/TopNav";
import { useNavigate } from "react-router-dom";
import "../App.css";

function ApplyPage() {
  const { id } = useParams(); // job ID
  const [job, setJob] = useState(null);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    area: "",
    phone: ""
  });

  const user = auth.currentUser;

  useEffect(() => {
    const fetchJob = async () => {
      const jobDoc = await getDoc(doc(db, "items", id));
      if (jobDoc.exists()) setJob(jobDoc.data());
    };
    const fetchUser = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setForm({
            name: data.name || "",
            email: data.email || user.email,
            area: data.area || "",
            phone: data.phone || ""
          });
        }
      }
    };
    fetchJob();
    fetchUser();
  }, [id, user]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user || !id) return;

    await setDoc(doc(db, `applicated/${id}/users`, form.name), {
      ...form,
      jobId: id,
      jobTitle: job?.name || "",
      appliedAt: new Date()
    });

    await setDoc(doc(db, `users/${user.uid}/applicated`, id), {
      ...form,
      jobId: id,
      jobTitle: job?.name || "",
      appliedAt: new Date()
    });

    alert("Application submitted!");
    navigate("/");
  };

  return (
    <div className="auth-container">
      <TopNav />
      <div className="apply-section">
        {job && (
          <div className="apply-job-header">
            <img src={job.image || "/no_image.png"} alt="Job" />
            <div>
              <h2>{job.name}</h2>
              <p>ID: {id}</p>
            </div>
          </div>
        )}

        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
          <input
            type="text"
            name="area"
            value={form.area}
            onChange={handleChange}
            placeholder="Your Area"
          />
          <input
            type="text"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Phone Number"
          />
          <button className="auth-btn login_btn" type="submit">
            Submit Application
          </button>
        </form>
      </div>
    </div>
  );
}

export default ApplyPage;
